import type { Component } from "solid-js";

/**
 * Simple spinner. Provide a `size-*` class to control size (defaults to size-3).
 * The border-t-transparent always wins so the spinning gap is visible.
 */
export const ProcessingSpinner: Component<{ class?: string }> = (props) => {
  return (
    <div
      class={`size-3 shrink-0 animate-spin rounded-full border border-blue-500 ${props.class ?? ""} border-t-transparent`}
    />
  );
};
